import fetch from 'utils/fetch'

// 登录  -----> 个人
export const userToken = (data) => fetch('get', '/oauth/user/token', data)
// 获取用户信息
export const userinfo = (data) => fetch('get', '/oauth/userinfo', data)
// 退出登录
export const removeToken = (data) => fetch('post', '/oauth/remove/token', data)
// 忘记密码
export const retrieve_pwd = (data) => fetch('get', '/person/account/retrieve_pwd', data)
// 注册
export const register = (data) => fetch('get', '/person/account/register', data)
// 手机验证码
export const send_sms_code = (data) => fetch('get', '/person/account/send_sms_code', data)
// 邮箱验证码
export const send_email_code = (data) => fetch('get', '/person/account/send_email_code', data)
// 企业修改密码
export const companyRetrieve_pwd = (data) => fetch('get', '/company/account/retrieve_pwd', data)

// ------> 个人信息

// 获取当前登录人个人信息
export const personOne = (data) => fetch('get', '/person/one', data)
// 公告列表
export const bulletinPage = (data) => fetch('get', '/bulletin/page', data)
// 公告详情
export const bulletinDetail = (data) => fetch('get', '/bulletin/detail', data)
// 保存个人信息
export const personSave = (data) => fetch('post', '/person/save', data)
// 学历列表
export const studyPage = (data) => fetch('get', '/person/study/page', data)
// 新增学习经历
export const studySave = (data) => fetch('post', '/person/study/save', data)
// 删除学习经历
export const studyRemove = (data) => fetch('get', '/person/study/remove', data)
// 工作经历列表
export const workPage = (data) => fetch('get', '/person/work/page', data)
// 新增工作经历
export const workSave = (data) => fetch('post', '/person/work/save', data)
// 删除工作经历
export const workRemove = (data) => fetch('get', '/person/work/remove', data)
// 看板
export const policy_statistics = (data) => fetch('post', '/person/policy/policy_statistics', data)

// ------> 企业
// 企业注册
export const companyRegister = (data) => fetch('post', '/company/register', data)
// 获取手机验证码
export const companySend_sms_code = (data) => fetch('get', '/company/account/send_sms_code', data)
// 企业看板
export const companyPolicy_statistics = (data) => fetch('get', '/company/policy/policy_statistics', data)
// 企业看板有效认定时间
export const companyPolicy_times = (data) => fetch('get', '/company/policy/expire/times', data)
// 企业编辑保存
export const companySave = (data) => fetch('post', '/company/save', data)
// 企业信息
export const companyOne = (data) => fetch('get', '/company/one', data)
// 获取企业信息
export const getCompanyDetail = (data) => fetch('get', '/company/one', data)
// 知识产权列表
export const companyPatentPage = (data) => fetch('get', '/company/patent/page', data)
// 新增知识产权列表
export const companyPatentAdd = (data) => fetch('post', '/company/patent/add', data)
// 删除知识产权列表
export const companyPatentRemove = (data) => fetch('get', '/company/patent/remove', data)
// 股权数据
export const companyOwnerShipPage = (data) => fetch('get', '/company/ownerShip/page', data)
// 新增股权数据
export const companyOwnerShipAdd = (data) => fetch('post', '/company/ownerShip/add', data)
// 删除股权数据
export const companyOwnerShipRemove = (data) => fetch('get', '/company/ownerShip/remove', data)
// 产业数据
export const industryCategory = (data) => fetch('get', '/common/industry/category', data)

// 查询户管单位
export const residenceDept = (data) => fetch('get', '/dept/residence/dept', data)
